import { HUB_PATH, LEADERBOARD_PATH } from '@/lib/components/RewardsHub/routes';
import { FEATURE_FLAGS } from '@/lib/config/features';
import {
  BUY_CRYPTO_PATH,
  CLAIM_PATH,
  COIN_FUTURES_PATH,
  FUTURES_POSITIONS_PATH,
  HISTORY_PATH,
  POSITIONS_PATH,
  USDC_FUTURES_PATH,
  USDT_FUTURES_PATH,
} from './routes';

/** `nav.*` label of a section. */
export type NavSectionKey = 'buyCrypto' | 'predictionMarkets' | 'cryptoTrading' | 'rewardsHub';

/** `nav.menu.<key>.title` label of a section's row. */
export type NavItemKey =
  | 'oneClickBuy'
  | 'cryptoDeposit'
  | 'convert'
  | 'markets'
  | 'myPositions'
  | 'history'
  | 'usdtFutures'
  | 'usdcFutures'
  | 'coinFutures'
  | 'myFutures'
  | 'allTasks'
  | 'claimRewards'
  | 'leaderboard';

/** A row that opens a wallet dialog instead of a page. */
export type NavItemAction = 'deposit' | 'convert';

/** Which counter a row carries. */
export type NavItemBadge = 'openPositions' | 'openFutures' | 'readyRewards';

export interface NavItem {
  key: NavItemKey;
  href?: string;
  action?: NavItemAction;
  badge?: NavItemBadge;
  /** Hidden from guests. */
  isAuthOnly?: boolean;
  /** A guest goes to sign-up instead: the target needs an account. */
  needsAccount?: boolean;
}

export interface NavSection {
  key: NavSectionKey;
  items: NavItem[];
}

// The burger drawer's sections (Figma 15071:148661), in the desktop nav's order.
const CRYPTO_TRADING: NavSection = {
  key: 'cryptoTrading',
  items: [
    { key: 'usdtFutures', href: USDT_FUTURES_PATH },
    { key: 'usdcFutures', href: USDC_FUTURES_PATH },
    { key: 'coinFutures', href: COIN_FUTURES_PATH },
    { key: 'myFutures', href: FUTURES_POSITIONS_PATH, badge: 'openFutures', isAuthOnly: true },
  ],
};

export const NAV_SECTIONS: NavSection[] = [
  {
    key: 'buyCrypto',
    items: [
      { key: 'oneClickBuy', href: BUY_CRYPTO_PATH, needsAccount: true },
      { key: 'cryptoDeposit', action: 'deposit', needsAccount: true },
      { key: 'convert', action: 'convert', needsAccount: true },
    ],
  },
  {
    key: 'predictionMarkets',
    items: [
      { key: 'markets', href: '/' },
      { key: 'myPositions', href: POSITIONS_PATH, badge: 'openPositions', isAuthOnly: true },
      { key: 'history', href: HISTORY_PATH, isAuthOnly: true },
    ],
  },
  ...(FEATURE_FLAGS.ENABLE_TRADE_ZONE ? [CRYPTO_TRADING] : []),
  {
    key: 'rewardsHub',
    items: [
      { key: 'allTasks', href: HUB_PATH },
      { key: 'claimRewards', href: CLAIM_PATH, badge: 'readyRewards', isAuthOnly: true },
      { key: 'leaderboard', href: LEADERBOARD_PATH },
    ],
  },
];
